import React, { useState, useEffect } from "react";
import {
  Box,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  IconButton,
} from "@mui/material";
import { fetchProducts, fetchModules } from "./../../API/CreateCollectionAPI";
import {
  // AddProductAPI,
  // AddCompanyURLAPI,
  // AddModuleAPI,
  // addEmailCredentialApi,
  // addDbCredentialApi,
  // fetchEmailCredentialDetails,
  // fetchDbCredentialDetails,
  // fetchUserDetails,
  // getUserApproved,
  // getuserReset,
  // clearStorage,
  // googleAuthcredentials,
  // getStaticIntegrations,
  // getIntegrations,
  // addIntegration,
  // deleteIntegrations,
  getUSerRoles,
  // updateUserType,
  getModulePermissions,
  updateModulePerm,
} from "./../../API/adminAPI";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ArrowDropDownSharpIcon from "@mui/icons-material/ArrowDropDownSharp";
// import { StyledTableRow, StyledTableCell } from "./StyledComponents";
import { StyledTableCell, StyledTableRow } from "../../components/common/common.Component";

const Permissions = () => {
  const ExpandTable = [
    // {
    //   name: "",
    //   id: "",
    //   isLongString: false,
    //   isNumeric: false,
    //   align: "center",
    //   colspan: 1,
    //   width: '10%',
    // },
    // {
    //   name: "Module Name",
    //   id: "Module Name",
    //   isLongString: false,
    //   isNumeric: false,
    //   align: "center",
    //   colspan: 1,
    //   width: '40%',
    // },
    // {
    //   name: "Permission",
    //   id: "Permission",
    //   isLongString: false,
    //   isNumeric: false,
    //   align: "center",
    //   colspan: 2,
    //   width: '30%',
    // },
    {
      name: "User Groups",
      id: "Product",
      isLongString: false,
      isNumeric: false,
      align: "center",
      colspan: 2,
      width: "60%",
    },
    {
      name: "Permissions",
      id: "permissions",
      isLongString: false,
      isNumeric: false,
      align: "center",
      colspan: 1,
      width: "40%",
    },
  ];
  const tableColumnsUserGroup = [
    // {
    //   name: "",
    //   id: "",
    //   isLongString: false,
    //   isNumeric: false,
    //   align: "center",
    //   colspan: 1,
    //   width: '15%',
    // },
    {
      name: "Module Name",
      id: "Module Name",
      isLongString: false,
      isNumeric: false,
      align: "center",
      colspan: 1,
      width: "25%",
    },
    {
      name: "Status",
      id: "status",
      isLongString: false,
      isNumeric: false,
      align: "center",
      colspan: 1,
      width: "25%",
    },
    // {
    //   name: "Module Name",
    //   id: "Product",
    //   isLongString: false,
    //   isNumeric: false,
    //   align: "center",
    //   colspan: 2,
    //   width: '25%',
    // },
    // {
    //   name: "Status",
    //   id: "Status",
    //   isLongString: false,
    //   isNumeric: false,
    //   align: "center",
    //   colspan: 1,
    //   width: '25%',
    // },
  ];
  const [productList, setproductList] = useState([]);
  const [userGroups, setUserGroup] = useState({
    idproducts: "",
    idmodules: "",
  });
  const [userRole, setUserRole] = useState([]);
  const [modulePermission, setModulePermission] = useState([]);
  const [moduleList, setModuleList] = useState([]);
  const [expandedRows, setExpandedRows] = useState({});
  const [selectStatus, setSelectStatus] = useState("");

  const getModules = async (api_input) => {
    await fetchModules(api_input)
      .then((response) => {
        if (response.status === 200) {
          if (response.data.message === "fail") {
          } else {
            setModuleList(response.data);
            console.log("resopooo", response.data);
          }
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };
  const handlegetUSerRoles = async () => {
    await getUSerRoles()
      .then((response) => {
        setUserRole(response.data);
      })
      .catch((error) => {
        console.log(error);
      });
  };
  useEffect(() => {
    handlegetUSerRoles();
  }, []);

  const toggleRowExpansion = (itemId) => {
    setExpandedRows((prevExpandedRows) => ({
      ...prevExpandedRows,
      [itemId]: !prevExpandedRows[itemId],
    }));
    console.log("fsd");
    getModulePermission(itemId);
  };
  const getProducts = async (api_input) => {
    await fetchProducts(api_input)
      .then((response) => {
        if (response.status === 200) {
          if (response.data.message === "fail") {
          } else {
            setproductList(response.data);
          }
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };
  const handleupdateModulePerm = async (moduleid, roleid, perm) => {
    await updateModulePerm(moduleid, roleid, perm)
      .then((response) => {
        if (response.status === 200 && response.data.message === "fail") {
        } else {
          const updatedModulePermission = modulePermission.map((item) =>
            item.roleid === roleid ? { ...item, permission: perm } : item,
          );

          setModulePermission(updatedModulePermission);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };
  const getModulePermission = async (idmodules) => {
    await getModulePermissions(idmodules)
      .then((response) => {
        if (response.status === 200 && response.data.message === "fail") {
        } else {
          setModulePermission(response.data);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };
  const renderExpandedRow = (moduleItem) => (
    <Table stickyHeader aria-label="nested table" sx={{ minWidth: 650 }} size="small">
      {expandedRows[moduleItem.idmodules] && (
        <>
          <TableHead>
            <StyledTableRow>
              {ExpandTable.map((item) => (
                <StyledTableCell
                  key={item.id}
                  align={item.align}
                  colSpan={item.colspan}
                  width={item.width}
                >
                  {item.name}
                </StyledTableCell>
              ))}
            </StyledTableRow>
          </TableHead>
          <TableBody>
            {userRole
              .filter((role) => role.user_role === "SUPER" || role.user_role === "USER")
              .map((role) => {
                const matchingPermission = modulePermission.find(
                  (perm) => perm.roleid === role.iduser_roles,
                );
                return (
                  <StyledTableRow key={role.iduser_roles}>
                    <StyledTableCell width="60%" align="center" colSpan={2}>
                      {role.user_role}
                    </StyledTableCell>
                    <StyledTableCell width="40%" align="center" colSpan={1}>
                      <FormControl>
                        <Select
                          variant="standard"
                          value={matchingPermission?.permission || "FullAccess"}
                          onChange={(event) =>
                            handleupdateModulePerm(
                              moduleItem.idmodules,
                              role.iduser_roles,
                              event.target.value,
                            )
                          }
                        >
                          <MenuItem value="FullAccess">Full Access</MenuItem>
                          <MenuItem value="ExecuteOnly">Execute Only</MenuItem>
                          <MenuItem value="ReadOnly">Read Only</MenuItem>
                        </Select>
                      </FormControl>
                    </StyledTableCell>
                  </StyledTableRow>
                )
              })}
          </TableBody>
        </>
      )}
    </Table>
  );
  const userGroup = () => {
    return (
      <div>
        <div
          style={{
            // backgroundColor: colors?.secondaryColor,
            // color: colors?.primaryColor,
            width: "100%",
          }}
        >
          {/* <Typography paddingBottom={0} variant="h6" component="h1"
              sx={{ display: "flex", justifyContent: "center", alignItems: "center" }}
            >
              User Group
            </Typography> */}
          <div>
            <div className="subheads">
              <FormControl
                sx={{
                  width: 240,
                  // color: colors.PrimaryColor
                }}
              >
                <InputLabel
                  style={{
                    // color: colors.primaryColor,
                    // backgroundColor: colors.secondaryColor,
                    padding: 5,
                  }}
                  id={"product"}
                >
                  Product
                </InputLabel>
                <Select
                  labelId={"product"}
                  id={"product Select"}
                  value={userGroup.idproducts}
                  onChange={(event) => {
                    setUserGroup({
                      ...userGroup,
                      idproducts: event.target.value,
                    });
                    getModules(event.target.value);
                    // getModulePermission(event.target.value)
                  }}
                  name={"product"}
                  label="product"
                  IconComponent={(props) => (
                    <ArrowDropDownSharpIcon
                      style={{
                        // color: colors.primaryColor,
                        fontSize: 40,
                      }}
                      {...props}
                    />
                  )}
                  sx={{
                    // color: colors.primaryColor,
                    // border: `2px solid ${colors.primaryColor}`,
                    fontSize: 16,
                    "&:focus": {
                      borderRadius: 4,
                      // border: `4px solid ${colors.primaryColor}`,
                    },
                  }}
                  style={{
                    minWidth: 100,
                    marginRight: "2rem",
                  }}
                >
                  {productList.map((product, index) => (
                    <MenuItem key={index} value={product.idproducts}>
                      {product.productname}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </div>
          </div>
        </div>
        {/*  */}
        <div style={{ display: "flex", justifyContent: "flex-start", overflow: "hidden" }}>
          <Table
            stickyHeader
            aria-label="a dense table"
            sx={{ minWidth: 650, marginTop: "10px", marginRight: 1 }}
          >
            <TableHead>
              <StyledTableRow>
                {tableColumnsUserGroup.map((item) => (
                  <>
                    <StyledTableCell
                      key={item.id}
                      align={item.align}
                      colSpan={item.colspan}
                      width={item.width}
                    >
                      {item.name}
                    </StyledTableCell>
                  </>
                ))}
                <StyledTableCell />
                <StyledTableCell colSpan={1} />
              </StyledTableRow>
            </TableHead>
            <TableBody>
              {moduleList.map((moduleItem, index) => {
                const handleStatusChange = (event) => {
                  setModuleList((prevModuleList) => {
                    const updatedModuleList = [...prevModuleList];
                    const index = updatedModuleList.findIndex(
                      (prevModuleItem) => prevModuleItem.idmodules === moduleItem.idmodules,
                    );
                    if (index !== -1) {
                      updatedModuleList[index] = {
                        ...moduleItem,
                        selectStatus: event.target.value,
                      };
                    }
                    return updatedModuleList;
                  });
                };
                if (index % 2 === 1) {
                  return (
                    <>
                      <StyledTableRow>
                        <StyledTableCell
                          key={moduleItem.id}
                          width="25%"
                          align="center"
                          sx={{ fontSize: 20 }}
                        >
                          {moduleItem.modulename}
                        </StyledTableCell>
                        <StyledTableCell width="25%" align="center" colSpan={1}>
                          {/* <FormControl>
                              <Select
                                variant="standard"
                                key={moduleItem.idmodules}
                                value={moduleItem.selectStatus}
                                onChange={handleStatusChange}
                              >
                                <MenuItem value="Full Access">Full Access</MenuItem>
                                <MenuItem value="Execute Only">Execute Only</MenuItem>
                                <MenuItem value="Read Only">Read Only</MenuItem>
                              </Select>
                            </FormControl> */}
                        </StyledTableCell>
                        <StyledTableCell width="30%" align="center" colSpan={2}>
                          <IconButton
                            color="inherit"
                            aria-label="expand more"
                            component="label"
                            onClick={() => toggleRowExpansion(moduleItem.idmodules)}
                          >
                            <ExpandMoreIcon />
                          </IconButton>
                        </StyledTableCell>
                      </StyledTableRow>
                      <div style={{ width: "134%" }}>
                        <Table
                          stickyHeader
                          aria-label="a dense table"
                          sx={{ minWidth: 650 }}
                          size="small"
                        >
                          {expandedRows[moduleItem.idmodules] && (
                            <>
                              <TableHead>
                                <StyledTableRow>
                                  {ExpandTable.map((item) => (
                                    <>
                                      {/* <StyledTableCell colSpan={1} /> */}
                                      <StyledTableCell
                                        key={item.id}
                                        align={item.align}
                                        colSpan={item.colspan}
                                        width={item.width}
                                      >
                                        {item.name}
                                      </StyledTableCell>
                                    </>
                                  ))}
                                  <StyledTableCell />
                                  <StyledTableCell colSpan={1} />
                                </StyledTableRow>
                              </TableHead>
                              <TableBody>
                                {userRole
                                  .filter((item) => item.user_role === "SUPER" || item.user_role === "USER")
                                  .map((item) => {
                                    console.log(item);
                                    const handleSelectStatusChange = (event) => {
                                      setSelectStatus((prevStatus) => {
                                        const updatedStatus = {
                                          ...prevStatus,
                                          [moduleItem.idmodules]: {
                                            ...prevStatus[moduleItem.idmodules],
                                            [item.id]: event.target.value,
                                          },
                                        };
                                        return updatedStatus;
                                      });
                                    };
                                    let matchingPermission = null;

                                    for (let i = 0; i < modulePermission.length; i++) {
                                      if (modulePermission[i].roleid === item.iduser_roles) {
                                        matchingPermission = modulePermission[i];
                                        break; // Exit the loop once a match is found
                                      }
                                    }
                                    const permission = matchingPermission
                                      ? matchingPermission.permission
                                      : "Full Access";

                                    return (
                                      <>
                                        <StyledTableRow>
                                          <StyledTableCell width="60%" align="center" colSpan={2}>
                                            {item.user_role}
                                          </StyledTableCell>

                                          <StyledTableCell width="40%" align="center" colSpan={1}>
                                            <FormControl>
                                              <Select
                                                variant="standard"
                                                key={moduleItem.idmodules}
                                                value={matchingPermission?.permission || "FullAccess"}
                                                onChange={(event) => {
                                                  handleupdateModulePerm(
                                                    moduleItem.idmodules,
                                                    item.iduser_roles,
                                                    event.target.value,
                                                  );
                                                }}
                                              >
                                                <MenuItem value="Full Access">Full Access</MenuItem>
                                                <MenuItem value="Execute Only">Execute Only</MenuItem>
                                                <MenuItem value="Read Only">Read Only</MenuItem>
                                              </Select>
                                            </FormControl>
                                          </StyledTableCell>
                                        </StyledTableRow>
                                      </>
                                    );
                                  })}
                              </TableBody>
                            </>
                          )}
                        </Table>
                      </div>
                    </>
                  );
                }
              })}
            </TableBody>
          </Table>
          <div>
            <Table
              stickyHeader
              aria-label="a dense table"
              sx={{ minWidth: 650, marginTop: "10px" }}
            >
              <TableHead>
                <StyledTableRow>
                  {tableColumnsUserGroup.map((item) => (
                    <>
                      {/* <StyledTableCell colSpan={1} /> */}
                      <StyledTableCell
                        key={item.id}
                        align={item.align}
                        colSpan={item.colspan}
                        width={item.width}
                      >
                        {item.name}
                      </StyledTableCell>
                    </>
                  ))}
                  <StyledTableCell />
                  <StyledTableCell colSpan={1} />
                </StyledTableRow>
              </TableHead>
              <TableBody>
                {moduleList.map((moduleItem, index) => {
                  const handleStatusChange = (event) => {
                    setModuleList((prevModuleList) => {
                      const updatedModuleList = [...prevModuleList];
                      const index = updatedModuleList.findIndex(
                        (prevModuleItem) => prevModuleItem.idmodules === moduleItem.idmodules,
                      );
                      if (index !== -1) {
                        updatedModuleList[index] = {
                          ...moduleItem,
                          selectStatus: event.target.value,
                        };
                      }
                      return updatedModuleList;
                    });
                  };
                  if (index % 2 === 0) {
                    return (
                      <>
                        <StyledTableRow>
                          <StyledTableCell
                            key={moduleItem.id}
                            width="25%"
                            align="center"
                            sx={{ fontSize: 20 }}
                          >
                            {moduleItem.modulename}
                          </StyledTableCell>
                          {/* {TableBodayData.map((item) => ( */}
                          <StyledTableCell width="25%" align="center" colSpan={1}>
                            {/* <FormControl>
                                <Select
                                  variant="standard"
                                  key={moduleItem.idmodules}
                                  value={moduleItem.selectStatus}
                                  onChange={handleStatusChange}
                                >
                                  <MenuItem value="Full Access">Full Access</MenuItem>
                                  <MenuItem value="Execute Only">Execute Only</MenuItem>
                                  <MenuItem value="Read Only">Read Only</MenuItem>
                                </Select>
                              </FormControl> */}
                          </StyledTableCell>
                          <StyledTableCell width="30%" align="center" colSpan={2}>
                            <IconButton
                              color="inherit"
                              aria-label="expand more"
                              component="label"
                              onClick={() => toggleRowExpansion(moduleItem.idmodules)}
                            >
                              <ExpandMoreIcon />
                            </IconButton>
                          </StyledTableCell>
                          {/* ))} */}
                        </StyledTableRow>
                        <div style={{ width: "125%" }}>
                          <Table
                            stickyHeader
                            aria-label="a dense table"
                            sx={{ minWidth: 650 }}
                            size="small"
                          >
                            {expandedRows[moduleItem.idmodules] && (
                              <>
                                <TableHead>
                                  <StyledTableRow>
                                    {ExpandTable.map((item) => (
                                      <>
                                        <StyledTableCell
                                          key={item.id}
                                          align={item.align}
                                          colSpan={item.colspan}
                                          width={item.width}
                                        >
                                          {item.name}
                                        </StyledTableCell>
                                      </>
                                    ))}
                                    <StyledTableCell />
                                    <StyledTableCell colSpan={1} />
                                  </StyledTableRow>
                                </TableHead>
                                <TableBody>
                                  {userRole
                                    .filter((item) => item.user_role === "SUPER" || item.user_role === "USER")
                                    .map((item) => {
                                      const handleSelectStatusChange = (event) => {
                                        setSelectStatus((prevStatus) => {
                                          const updatedStatus = {
                                            ...prevStatus,
                                            [moduleItem.idmodules]: {
                                              ...prevStatus[moduleItem.idmodules],
                                              [item.id]: event.target.value,
                                            },
                                          };
                                          return updatedStatus;
                                        });
                                        // const dropdownId = item.id;
                                        // setSelectStatus((prevStatus) => {
                                        //   const updatedStatus = { ...prevStatus, [dropdownId]: event.target.value };
                                        //   return updatedStatus;
                                        // });
                                      };
                                      let matchingPermission = null;

                                      for (let i = 0; i < modulePermission.length; i++) {
                                        if (modulePermission[i].roleid === item.iduser_roles) {
                                          matchingPermission = modulePermission[i];
                                          break; // Exit the loop once a match is found
                                        }
                                      }
                                      const permission = matchingPermission
                                        ? matchingPermission.permission
                                        : "Full Access";

                                      return (
                                        <>
                                          <StyledTableRow>
                                            {/* <StyledTableCell width='40%' align="center" colSpan={1}>
                                                    {item.name}
                                                  </StyledTableCell> */}
                                            <StyledTableCell width="60%" align="center" colSpan={2}>
                                              {item.user_role}
                                            </StyledTableCell>
                                            <StyledTableCell width="40%" align="center" colSpan={1}>
                                              <FormControl>
                                                <Select
                                                  variant="standard"
                                                  key={moduleItem.idmodules}
                                                  // value={selectStatus}
                                                  // onChange={(event) => {
                                                  //   setSelectStatus(event.target.value)
                                                  // }}
                                                  // value={selectStatus[item.id] || 'Full Access'}
                                                  value={
                                                    matchingPermission?.permission || "FullAccess"
                                                  }
                                                  onChange={(event) => {
                                                    handleupdateModulePerm(
                                                      moduleItem.idmodules,
                                                      item.iduser_roles,
                                                      event.target.value,
                                                    );
                                                  }}
                                                >
                                                  <MenuItem value="FullAccess">Full Access</MenuItem>
                                                  <MenuItem value="ExecuteOnly">
                                                    Execute Only
                                                  </MenuItem>
                                                  <MenuItem value="ReadOnly">Read Only</MenuItem>
                                                </Select>
                                              </FormControl>
                                            </StyledTableCell>
                                          </StyledTableRow>
                                        </>
                                      );
                                    })}
                                </TableBody>
                              </>
                            )}
                          </Table>
                        </div>
                      </>
                    );
                  }
                })}
              </TableBody>
            </Table>
          </div>
        </div>
      </div>
    );
  };

  useEffect(() => {
    getProducts();
    // getUserData();
  }, []);
  return (
    <div>
      {/* Product dropdown */}
      <FormControl sx={{ width: 240, mb: 2 }}>
        <InputLabel id="product">Product</InputLabel>
        <Select
          labelId="product"
          value={userGroup.idproducts}
          onChange={(e) => {
            setUserGroup({ ...userGroup, idproducts: e.target.value });
            getModules(e.target.value);
          }}
        >
          {productList.map((product) => (
            <MenuItem key={product.idproducts} value={product.idproducts}>
              {product.productname}
            </MenuItem>
          ))}
        </Select>
      </FormControl>

      {/* Main table */}
      <Table stickyHeader aria-label="modules table" sx={{ minWidth: 650 }}>
        <TableHead>
          <StyledTableRow>
            {tableColumnsUserGroup.map((item) => (
              <StyledTableCell
                key={item.id}
                align={item.align}
                colSpan={item.colspan}
                width={item.width}
              >
                {item.name}
              </StyledTableCell>
            ))}
          </StyledTableRow>
        </TableHead>

        <TableBody>
          {moduleList.map((moduleItem, index) => (
            <React.Fragment key={moduleItem.idmodules}>
              <StyledTableRow sx={{ backgroundColor: index % 2 === 0 ? "#fafafa" : "#fff" }}>
                <StyledTableCell align="center" sx={{ fontSize: 20 }}>
                  {moduleItem.modulename}
                </StyledTableCell>
                <StyledTableCell align="center" colSpan={1}></StyledTableCell>
                <StyledTableCell align="center" colSpan={2}>
                  <IconButton
                    color="inherit"
                    onClick={() => toggleRowExpansion(moduleItem.idmodules)}
                  >
                    <ExpandMoreIcon />
                  </IconButton>
                </StyledTableCell>
              </StyledTableRow>

              {/* Expanded content */}
              <TableRow>
                <TableCell colSpan={4} sx={{ p: 0 }}>
                  {renderExpandedRow(moduleItem)}
                </TableCell>
              </TableRow>
            </React.Fragment>
          ))}
        </TableBody>
      </Table>
    </div>
  );
};

export default Permissions;
